import { Injectable } from '@angular/core';
import { HttpHandler, HttpHeaderResponse, HttpHeaders, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { TokenStorage } from './token-storage';
import { from, mergeMap, Observable, of, switchMap } from 'rxjs';
import { FingerprintjsProAngularService } from '@fingerprintjs/fingerprintjs-pro-angular';
import { DeviceDetectorService } from 'ngx-device-detector';
const TOKEN_HEADER_KEY = 'Authorization';
const deviceTimeZone = new Date().toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'long' }).substring(4)
//const TOKEN_REFRESH_TOKEN = 'refresh_token';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  position: any
  publicIpAddr: any;
  deviceIpAddrs : any;
  constructor(private token: TokenStorage, 
    private deviceService: DeviceDetectorService,
   ) {
    // this.accsrvc.getPosition().then(pos => {
    //   //console.log(`Positon: ${pos.lng} ${pos.lat}`);
    //   this.position = {
    //     latitude: pos.lat,
    //     longitude: pos.lng
    //   }
    // });
  }
async getIPAddress() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching IP address:', error);
      return null;
    }
  }
async goToGetIPAddress() {
   const ipAddress = await this.getIPAddress();
   return ipAddress;

  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    let lang = '';
    let userSettings = window.localStorage.getItem('userSettings');
    if(userSettings) {
      let userSettingParsed = JSON.parse(userSettings);
      lang = userSettingParsed.lang;
    } else {
      lang = 'en'
    }
    // Replace it with your method
    // return from(this.fingerprintjsProAngularService.getVisitorData()).pipe(
    //   switchMap((result: { visitorId: any; }) => {
        // return from(this.goToGetIPAddress()).pipe(
        //   mergeMap(ipAddress => {
            let clientInfo = {
              deviceID: "jNjzq8lJ7ic2T15sKBPE",
              deviceID2: "jNjzq8lJ7ic2T15sKBPE",
              deviceTimeZone: deviceTimeZone,
              // deviceIpAddress: ipAddress,
              // deviceLatitude: this.position ? this.position.latitude : "",
              // deviceLongitude: this.position ? this.position.longitude : "",
              deviceIpAddress : '192.168.0.1',
              deviceLatitude : '37.7749',
              deviceLongitude : '122.4194',
              deviceType: this.deviceService.deviceType,
              deviceModel: this.deviceService.os,
              deviceVersion: this.deviceService.os_version,
              deviceUserID: window.navigator.userAgent,
              deviceAppVersion: '1.0.8',
              deviceIsJailBroken: false,
              language: lang
            };
            let headers = req.headers
              .set('fingerprint', "jNjzq8lJ7ic2T15sKBPE")
              .append('orgAppID', '6210').append('clientInfo', JSON.stringify(clientInfo));
            if (this.token.get()) {
              headers = headers.append(TOKEN_HEADER_KEY, `Bearer ${this.token.get()}`); // assign the updated headers to the headers variable
            }
           
            const requestClone = req.clone({
              headers,
            });
            return next.handle(requestClone);            
            
        //   })
        // )
      //})
    //);
    
    //return next.handle(req);
    }
}
